import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, LeafIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/wfCwzazkJgFyupSqRqJKQJ/heylloyd-image-1771802598740_reset_cortisol.png';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* Sticky Nav */}
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-sage/20 shadow-sm" data-id="element-33">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-34">
          <span className="font-serif text-forest font-semibold text-sm md:text-base tracking-wide" data-id="element-35">
            The Cortisol Reset Kitchen
          </span>
          <button onClick={scrollToOffer} className="bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-xs md:text-sm px-4 py-2 rounded-full transition-all duration-200 shadow-sm hover:shadow-md" data-id="element-36">
            Get Instant Access — $27
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-cream relative overflow-hidden pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-37">
        {/* Decorative botanical SVG — top left */}
        <svg className="absolute top-0 left-0 w-48 md:w-72 opacity-10 text-sage pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-38">
          <path d="M10 180 Q 60 80 100 20 Q 140 80 190 180" stroke="#8FAF8A" strokeWidth="2" fill="none" data-id="element-39" />
          <path d="M50 160 Q 80 100 100 60 Q 120 100 150 160" stroke="#8FAF8A" strokeWidth="1.5" fill="none" data-id="element-40" />
          <ellipse cx="100" cy="20" rx="12" ry="18" fill="#8FAF8A" opacity="0.4" data-id="element-41" />
          <ellipse cx="60" cy="90" rx="8" ry="14" fill="#8FAF8A" opacity="0.3" transform="rotate(-20 60 90)" data-id="element-42" />
          <ellipse cx="140" cy="90" rx="8" ry="14" fill="#8FAF8A" opacity="0.3" transform="rotate(20 140 90)" data-id="element-43" />
          <ellipse cx="30" cy="150" rx="6" ry="10" fill="#8FAF8A" opacity="0.25" transform="rotate(-35 30 150)" data-id="element-44" />
          <ellipse cx="170" cy="150" rx="6" ry="10" fill="#8FAF8A" opacity="0.25" transform="rotate(35 170 150)" data-id="element-45" />
        </svg>

        {/* Decorative botanical SVG — bottom right */}
        <svg className="absolute bottom-0 right-0 w-48 md:w-72 opacity-10 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-46">
          <path d="M190 20 Q 140 120 100 180 Q 60 120 10 20" stroke="#8FAF8A" strokeWidth="2" fill="none" data-id="element-47" />
          <ellipse cx="100" cy="180" rx="12" ry="18" fill="#8FAF8A" opacity="0.4" data-id="element-48" />
          <ellipse cx="60" cy="110" rx="8" ry="14" fill="#8FAF8A" opacity="0.3" transform="rotate(20 60 110)" data-id="element-49" />
          <ellipse cx="140" cy="110" rx="8" ry="14" fill="#8FAF8A" opacity="0.3" transform="rotate(-20 140 110)" data-id="element-50" />
        </svg>

        <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-51">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-52">
            {/* Left: Copy */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} data-id="element-53">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 bg-sage/20 border border-sage/40 text-forest rounded-full px-4 py-1.5 mb-6" data-id="element-54">
                <LeafIcon className="w-3.5 h-3.5 text-forest" aria-hidden="true" data-id="element-55" />
                <span className="font-sans text-xs font-700 tracking-widest uppercase" data-id="element-56">
                  For Women 50+ Only
                </span>
              </div>

              <h1 className="font-serif text-forest text-3xl md:text-4xl lg:text-5xl font-700 leading-tight mb-5" data-id="element-57">
                The Cortisol Belly Blueprint: Why Women 50+ Can't Lose Weight
                Like They Used To
              </h1>

              <p className="font-sans text-stone-600 text-lg leading-relaxed mb-8" data-id="element-58">
                Discover the 21-Day Thermal Window Protocol — the kitchen-based
                system that targets the ONE hormone making your midsection
                impossible to shrink.
              </p>

              <button onClick={scrollToOffer} className="w-full md:w-auto bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-4" data-id="element-59">
                Yes! I Want My Cortisol Reset — $27
              </button>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-stone-500 text-sm font-sans" data-id="element-60">
                <span className="flex items-center gap-1.5" data-id="element-61">
                  <ShieldCheckIcon className="w-4 h-4 text-sage" aria-hidden="true" data-id="element-62" />
                  60-Day Money-Back Guarantee
                </span>
                <span className="flex items-center gap-1.5" data-id="element-63">
                  <DownloadIcon className="w-4 h-4 text-sage" aria-hidden="true" data-id="element-64" />
                  Instant Digital Download
                </span>
                <span className="text-stone-400" data-id="element-65">No Dieting Required</span>
              </div>
            </motion.div>

            {/* Right: Product Image */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut'
          }} className="flex justify-center" data-id="element-66">
              <div className="relative" data-id="element-67">
                <div className="absolute inset-0 bg-sage/20 rounded-3xl blur-2xl transform scale-95 translate-y-4" aria-hidden="true" data-id="element-68" />
                <img src={PRODUCT_IMAGE} alt="The Cortisol Reset Kitchen — digital guide shown on tablet" className="relative w-full max-w-sm md:max-w-md rounded-2xl shadow-2xl" data-id="element-69" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}